import axiosInstance from './axios';

/**
 * API para gestión de Master Requirements pendientes de validación
 */

/**
 * Obtener lista paginada de Master Requirements pendientes de validación
 * @param {number} page - Número de página
 * @param {number} pageSize - Tamaño de página
 * @returns {Promise} Promise con los datos de requisitos pendientes
 */
export const getPendingRequirements = async (page = 1, pageSize = 20) => {
  const response = await axiosInstance.get('/master-requirements/pending/', {
    params: { page, page_size: pageSize }
  });
  return response.data;
};

/**
 * Obtener conteo de Master Requirements pendientes de validación
 * @returns {Promise} Promise con el conteo
 */
export const getPendingCount = async () => {
  const response = await axiosInstance.get('/master-requirements/pending/count/');
  return response.data;
};

/**
 * Aprobar un Master Requirement pendiente
 * @param {number} requirementId - ID del requisito a aprobar
 * @param {Object} data - Datos opcionales (edited_spec_name, edited_spec_text, notes)
 * @returns {Promise} Promise con resultado de la aprobación
 */
export const approveRequirement = async (requirementId, data = {}) => {
  const response = await axiosInstance.post(
    `/master-requirements/${requirementId}/approve/`,
    data
  );
  return response.data;
};

/**
 * Rechazar un Master Requirement pendiente
 * @param {number} requirementId - ID del requisito a rechazar
 * @param {string} reason - Razón del rechazo
 * @returns {Promise} Promise con resultado del rechazo
 */
export const rejectRequirement = async (requirementId, reason) => {
  const response = await axiosInstance.post(
    `/master-requirements/${requirementId}/reject/`,
    { reason }
  );
  return response.data;
};

/**
 * Eliminar todos los Master Requirements pendientes de validación
 * Solo accesible para Admin
 * @returns {Promise} Promise con resultado de la eliminación
 */
export const deleteAllPendingRequirements = async () => {
  const response = await axiosInstance.delete('/master-requirements/pending/delete-all/');
  return response.data;
};
